module.exports = __webpack_public_path__ + "assets/twitter-dark.29b0c7a6.svg";